import React, { useContext, useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Typography, Grid, Box } from "@mui/material";
import { ThemeContext } from "../../../context/ThemeContext";
import { useTranslation } from "react-i18next";
import BidValue from '../../global/BidAsk/BidValue';
import AskValue from '../../global/BidAsk/AskValue';
import toast from "react-hot-toast";

const ClosePosition = ({ open, onClose, selectedPosition, onConfirm }) => {
    const { darkMode } = useContext(ThemeContext)
    const { t } = useTranslation()
    const [amount, setAmount] = useState(selectedPosition?.amount)

  useEffect(() => {
        if (selectedPosition) {
            setAmount(selectedPosition.amount ?? "");
        }
    }, [selectedPosition])
        const handleConfirm = () => {
        const inputAmount = Number(amount);
        const maxAmount = Number(selectedPosition?.amount);

        if (isNaN(inputAmount) || inputAmount <= 0) {
            toast.error("Amount must be a valid number greater than 0.");
            return;
        }

        if (inputAmount > maxAmount) {
            toast.error(`Amount must not exceed ${maxAmount}`);
            return;
        }

        onConfirm(inputAmount);
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle sx={{ color: "white", p: 1 }} className="bg-primary">
                <Typography variant="body1" sx={{ color: darkMode ? "var(--white)" : "var(--white)" }} align="center" >{t('ClosePosition')} ({selectedPosition?.symbolName})</Typography>
            </DialogTitle>
            <DialogContent sx={{ backgroundColor: darkMode ? "#151924" : "#f5f5f5", }}>
                <Grid container spacing={2} sx={{ mt: 1 }} alignItems='center'>
                    <Grid item xs={6} sx={{ mb: 2 }}>
                        <Typography variant="subtitle2" sx={{ textAlign: 'center' }}>{t('bid')}</Typography>
                        <Box sx={{ display: "flex", justifyContent: 'center' }}><BidValue symbolId={selectedPosition?.symbolId} digits={selectedPosition?.digits} /></Box>
                    </Grid>
                    <Grid item xs={6} sx={{ mb: 2 }}>
                        <Typography variant="subtitle2" sx={{ textAlign: 'center' }}>{t('ask')}</Typography>
                        <Box sx={{ display: "flex", justifyContent: 'center' }}><AskValue symbolId={selectedPosition?.symbolId} digits={selectedPosition?.digits} /></Box>
                    </Grid>
                    <Grid item xs={3}><Typography variant="subtitle2" sx={{ textAlign: 'right' }}>{t('amount')}</Typography></Grid>
                    <Grid item xs={9}><TextField value={amount} inputProps={{max: selectedPosition?.amount ?? undefined,}} onChange={(e) => setAmount(e.target.value)} fullWidth /></Grid>

                </Grid>
            </DialogContent>
            <DialogActions sx={{ backgroundColor: darkMode ? "#151924" : "#f5f5f5", }}>
                <Button onClick={onClose} variant="outlined">{t('cancel')}</Button>
                <Button onClick={handleConfirm} color="primary" variant="contained">{t('ClosePosition')}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ClosePosition;
